import React from "react";
import {ShowcaseLayout} from "./layout/ShowcaseLayout.jsx";
import {GridContainerFlex} from "../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";
import {HeadingText} from "../../components/base/typography/HeadingText.jsx";
export const Showcase = () => {

    return (
        <ShowcaseLayout>
            <GridContainerFlex>
                <GridItemFlex><HeadingText type={"h3"}>Showcase landing page</HeadingText></GridItemFlex>
            </GridContainerFlex>
        </ShowcaseLayout>
    );
};
